import React, { Component, createRef } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faXmark,
  faCheck,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import * as XLSX from 'xlsx';
import ModalBasic from "../component/ModalBasic.js";
import { printFunction } from "../../components/print/printTemplate.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class RMFormula extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      selectionPopUp: false,
      isSelect: false,
      selectAll: false,
      productDropdownList: [],
      tableStatus: "",
      productId: "",
      batchSize: "",
      selectionId: "",
      isLoading: false,
      rmFormulaList: [],
      rmFormulaListForSelection: [],
      productionStageList: [],
      rawMaterialList: [],
      netQtyCount: 0,
      qtyCount: 0,
      rmUOMList: [
        { label: "GM", value: 1 },
        { label: "KGS", value: 2 },
        { label: "IU", value: 3 },
        { label: "LTR", value: 4 },
        { label: "MCG", value: 5 },
        { label: "MG", value: 6 },
        { label: "ML", value: 7 },
        { label: "NOS", value: 8 },
      ],
      supplyList: [{ supply: "Yes" }, { supply: "No" }],
      isHideAddItem: false,
    };
  }

  componentDidMount() {
    this.getAllProductDropdown();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllProductDropdown = () => {

    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {

        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          this.getAllProductionStageMaster();
        });
      } else {

        this.getAllProductionStageMaster();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllProductionStageMaster = () => {
    this.commonServices.getAllProductionStageMaster().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.stageName,
          value: item._id,
        }));
        this.setState({ productionStageList: dropdownItems }, () => {
          this.getAllRMDropdown();
        });
      } else {
        this.getAllRMDropdown();
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
        }));
        this.setState({ rawMaterialList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  setFilterParametersForItemName = (selected, drpIdentity) => {
    if (selected.value) {
      if (drpIdentity === 'selectionId') {
        this.setState({ selectionId: selected.value }, () => {
          this.getRMFormulaByProductIdForSelection();
        });
      } else {
        this.setState({ productId: selected.value }, () => {
          this.getRMFormulaByProductId();
        });
      }
    }
  };

  getRMFormulaByProductId = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.productId;
    this.itemMasterServices
      .getRMFormulaByProductId(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let array = response.responseData;
          if (array.length === 0) {
            this.setState({ isSelect: true })
          } else {
            this.setState({ isSelect: false })
          }
          const qtyCount = array.reduce((sum, item) => sum + Number(item.qty), 0);
          const netQtyCount = array.reduce((sum, item) => sum + Number(item.netQty), 0);

          this.setState({ qtyCount: qtyCount, netQtyCount: netQtyCount })

          array.map((product) => {
            product.isEditing = false;
          });

          let batchSize = response.responseData.length > 0 ? response.responseData.find(x => x.batchSize > 0) ? response.responseData.find(x => x.batchSize > 0).batchSize : 0 : 0
          this.setState({ rmFormulaList: array, batchSize: batchSize }, () => {
            let filteredArray = this.state.rmFormulaList.filter(
              (x) => x.productId === ""
            );
            if (filteredArray.length === 0) {
              this.setState({ isHideAddItem: false });
            }
          });
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(response.Message);
        }
      });
  };

  getRMFormulaByProductIdForSelection = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.selectionId;
    this.itemMasterServices
      .getRMFormulaByProductId(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let array = response.responseData;

          const qtyCount = array.reduce((sum, item) => sum + Number(item.qty), 0);
          const netQtyCount = array.reduce((sum, item) => sum + Number(item.netQty), 0);

          this.setState({ qtyCount: qtyCount, netQtyCount: netQtyCount })

          array.map((product) => {
            product.checkRMFormula = false;
          });
          this.setState({ rmFormulaListForSelection: array }, () => {
            let filteredArray = this.state.rmFormulaListForSelection.filter(
              (x) => x.productId === ""
            );
            if (filteredArray.length === 0) {
              this.setState({ isHideAddItem: false });
            }
          });
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(response.Message);
        }
      });
  };

  setFilterParameters = (selected, fieldName, key) => {
    if (fieldName) {
      if (fieldName === 'rmName') {
        let value = selected.label;
        const updatedList = this.state.rmFormulaList.map((item, index) =>
          index === key ? { ...item, [fieldName]: value, rmId: selected.value } : item
        );
        this.setState({ rmFormulaList: updatedList });
      } else {
        let value = selected.label;
        const updatedList = this.state.rmFormulaList.map((item, index) =>
          index === key ? { ...item, [fieldName]: value } : item
        );
        this.setState({ rmFormulaList: updatedList });
      }
    }
  };

  addItemforParty = () => {
    this.setState({ isHideAddItem: true });
    let partyWiseArray = this.state.rmFormulaList.map((item) => ({
      ...item,
      isEditing: false,
    }));
    let newItem = {
      stageName: "",
      productId: this.state.productId,
      rmName: "",
      lcQty: 0,
      lcUOM: "",
      qty: 0,
      uom: "",
      loss: 0,
      netQty: 0,
      weight: 0,
      isEditing: true,
    };
    partyWiseArray.unshift(newItem);
    this.setState({ rmFormulaList: partyWiseArray });
  };

  editDetails = (index) => {
    let array = this.state.rmFormulaList.map((item, i) => {
      return {
        ...item,
        isEditing: i === index,
      };
    });
    this.setState({ rmFormulaList: array });
  };

  cancelEditing = (id, index) => {
    if (id !== "") {
      let partyWiseArray = this.state.rmFormulaList.map((item) => ({
        ...item,
        isEditing: false,
      }));
      this.setState({ rmFormulaList: partyWiseArray }, () => {
        this.getRMFormulaByProductId()
      });
    } else {
      let partyWiseArray = [...this.state.rmFormulaList];
      partyWiseArray.splice(index, 1);
      this.setState({ rmFormulaList: partyWiseArray }, () => {
        let filteredArray = this.state.rmFormulaList.filter(
          (x) => x.productId === ""
        );
        if (filteredArray.length === 0) {
          this.setState({ isHideAddItem: false }, () => {
            this.getRMFormulaByProductId()
          });
        }
      });
    }
  };

  // handleChange = (event, fieldName, key) => {
  //   const { value } = event.target;
  //   const updatedList = this.state.rmFormulaList.map((item, index) =>
  //     index === key ?
  //       {
  //         ...item,
  //         [fieldName]: value,
  //         netQty: (fieldName === 'loss' || fieldName === 'qty') ? (item.qty * (1 + (Number(item.loss) > 0 ? Number(item.loss) : 0) / 100)) : item.netQty
  //       }
  //       : item
  //   );
  //   this.setState({ rmFormulaList: updatedList });
  // };

  handleChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.rmFormulaList.map((item, index) => {
      if (index !== key) return item;

      const updatedItem = {
        ...item,
        [fieldName]: value
      };

      const qty = fieldName === 'qty' ? Number(value) : Number(updatedItem.qty);
      const loss = fieldName === 'loss' ? Number(value) : Number(updatedItem.loss);

      updatedItem.netQty = (qty * (1 + (loss > 0 ? loss : 0) / 100)).toFixed(2);

      return updatedItem;
    });

    this.setState({ rmFormulaList: updatedList });
  };


  handleDropdownChange = (event, fieldName, key) => {
    const { value } = event.target;
    const updatedList = this.state.rmFormulaList.map((item, index) =>
      index === key ? { ...item, [fieldName]: value } : item
    );
    this.setState({ rmFormulaList: updatedList });
  };

  addEditRMFormulaDetails = (itemDetails) => {
    if (itemDetails.productId !== "" && itemDetails.stageName !== "" && itemDetails.qty !== "" && itemDetails.uom !== "" && itemDetails.netQty !== "") {
      let request = itemDetails;
      request.productId = this.state.productId;
      // request.batchSize = this.state.batchSize;
      let stages = this.state.productionStageList.find(x => x.label === itemDetails.stageName)
      request.stageId = (stages && stages !== undefined) ? stages.value : null
      request.rmId = (itemDetails.rmId && itemDetails.rmId !== undefined) ? itemDetails.rmId : this.state.rawMaterialList.find(x => x.label === itemDetails.rmName).value
      this.itemMasterServices.addEditRMFormulaDetails(request).then((response) => {
        if (response.statusCode === 200 && response.responseData !== null) {
          this.SwalServices.Success(response.Message);
          this.getRMFormulaByProductId();
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
    } else {
      this.SwalServices.Alert("Please fill all the required things.");
    }
  };

  deleteRMFurmulaById = (id) => {
    if (id && id !== "") {
      this.itemMasterServices.deleteRMFurmulaById(id).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          this.SwalServices.Success(response.Message);
          this.getRMFormulaByProductId();
        } else {
          this.SwalServices.Error(
            response.Message
          );
        }
      });
    }
  };

  // printRMFormulaData = () => {
  //   const { rmFormulaList } = this.state;

  //   const transformedData = rmFormulaList.map((item, index) => ({
  //     'SN': index + 1,
  //     'Stage Name': item.stageName,
  //     'Material Name': item.rmName,
  //     'L.C.Qty': item.lcQty.toFixed(2),
  //     'Qty': item.qty.toFixed(2),
  //     'U-O-M': item.uom,
  //     'Ovrg.[%]': item.loss.toFixed(2),
  //     'Net Qty': item.netQty.toFixed(2),
  //     'Weight': item.weight,
  //   }));

  //   transformedData.push({
  //     'SN': '',
  //     'Stage Name': '',
  //     'Material Name': '',
  //     'L.C.Qty': '',
  //     'Qty': '',
  //     'U-O-M': '',
  //     'Ovrg.[%]': '',
  //     'Net Qty': `Total: ${this.state.netQtyCount}`, // Add total here
  //     'Weight': '',
  //   });

  //   const worksheet = XLSX.utils.json_to_sheet(transformedData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'PM Formula List');
  //   XLSX.writeFile(workbook, 'RMFormulaList.xlsx');
  // }

  printRMFormulaData = () => {
    const printContent = this.printRef.current;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();

    document.body.innerHTML = originalContent;
    window.location.reload();
  };

  selectRMFormulaForNewProduct = () => {
    this.resetSelectPopup();
    this.setState({ selectionPopUp: !this.state.selectionPopUp });
  }

  resetSelectPopup = () => {
    this.setState({ selectionId: "", rmFormulaListForSelection: [], selectAll: false, });

  };
  setModalOpen = () => {
    this.setState({ selectionPopUp: !this.state.selectionPopUp });
  };

  handleChangeForImportRMs = (event, index) => {
    let checked = event.target.checked
    let list = [...this.state.rmFormulaListForSelection];
    list[index].checkRMFormula = checked;
    this.setState({ rmFormulaListForSelection: list });
  }

  handleChangeForSelectAll = (event) => {
    let checked = event.target.checked;
    let list = this.state.rmFormulaListForSelection.map(item => ({ ...item, checkRMFormula: checked }));
    this.setState({ selectAll: checked, rmFormulaListForSelection: list });
  };


  importAllRMFormula = async () => {
    let list = this.state.rmFormulaListForSelection.filter(x => x.checkRMFormula === true);
    if (list.length > 0) {
      this.setState({ isLoading: true })
      for (const details of list) {
        let itemDetails = {
          productId: this.state.productId,
          ID: details.ID,
          productCode: details.productCode,
          batchSize: details.batchSize,
          weight: details.weight,
          stageId: details.stageId?._id,
          itemCode: details.itemCode,
          qty: details.qty,
          netQty: details.netQty,
          lcQty: details.lcQty,
          lcUOM: details.lcUOM,
          lcPer: details.lcPer,
          uom: details.uom,
          loss: details.loss,
          entDate: details.entDate,
          rmName: details.rmName,
          stageName: details.stageName,
          stCode: details.stCode,
          stkCode: details.stkCode,
          stkName: details.stkName,
          rmId: details.rmId
        };

        await new Promise(resolve => {
          this.setState({ batchSize: details.batchSize }, resolve);
        });
        await this.addEditRMFormulaDetails(itemDetails);
      }
      this.setState({ selectionPopUp: false, isLoading: false });
    } else {
      this.SwalServices.Alert('Please Select RM Formula')
    }
  };


  handleChangeForBatchSize = (event) => {
    let value = event.target.value
    this.setState({ batchSize: value })
  }

  deleteAllRMFormula = () => {
    let list = this.state.rmFormulaList;
    if (list.length === 0) {
      this.SwalServices.Warning("No RM formulas to delete.");
      return;
    }
    Promise.all(
      list.map((item) => this.itemMasterServices.deleteRMFurmulaById(item._id))
    )
      .then((responses) => {
        let allSuccessful = responses.every(
          (response) => response.statusCode === 200 && response.responseData != null
        );
        if (allSuccessful) {
          this.SwalServices.Success("All RM formulas deleted successfully.");
          this.getRMFormulaByProductId();
        } else {
          this.SwalServices.Error("Some RM formulas could not be deleted.");
        }
      })
      .catch((error) => {
        this.SwalServices.Error("Error deleting RM formulas.");
        console.error("Delete error:", error);
      });
  };

  updateBatchSizeInBatchSize = async () => {
    let list = this.state.rmFormulaList;
    if (list.length > 0) {
      for (const details of list) {
        let itemDetails = {
          _id: details._id,
          productId: this.state.productId,
          ID: details.ID,
          productCode: details.productCode,
          batchSize: this.state.batchSize,
          weight: details.weight,
          stageId: details.stageId?._id,
          itemCode: details.itemCode,
          qty: details.qty,
          netQty: details.netQty,
          lcQty: details.lcQty,
          lcUOM: details.lcUOM,
          lcPer: details.lcPer,
          uom: details.uom,
          loss: details.loss,
          entDate: details.entDate,
          rmName: details.rmName,
          stageName: details.stageName,
          stCode: details.stCode,
          stkCode: details.stkCode,
          stkName: details.stkName,
          rmId: details.rmId
        };

        await new Promise(resolve => {
          this.setState({ batchSize: this.state.batchSize }, resolve);
        });
        await this.addEditRMFormulaDetails(itemDetails);
      }
    } else {
      this.SwalServices.Alert('Please Select RM Formula')
    }
  }

  render() {
    return (
      <>
        <div className="rmFormula-page">
          <div className="item-search">
            <div className="item-grp flex gap-2.5">
              <div className="item-search-box" style={{ width: "30%" }}>
                <label>Item Name</label>
                <MultiSelectDropdown
                  drpIdentity="productId"
                  options={this.state.productDropdownList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) =>
                    this.setFilterParametersForItemName(selected, "productId")
                  }
                  allowSelectAll={false}
                  value={this.state.productDropdownList.filter(
                    (party) => party.value === this.state.productId
                  )}
                />
              </div>
              <div className="flex gap-1.5">
                <div className="item-search-box " style={{ width: "100% - 40px" }} >
                  <label>Batch Size</label>
                  <input
                    className="inputFocus"
                    type="number"
                    id="batchSize"
                    name="batchSize"
                    value={this.state.batchSize}
                    autocomplete="off"
                    onChange={(event) =>
                      this.handleChangeForBatchSize(event)
                    }
                  />
                </div>
                <button
                  className="done-btn mt-auto !w-[40px] !h-[40px] !p-[5px] flex justify-center items-center"
                  onClick={() => this.updateBatchSizeInBatchSize()}
                  title="Save"
                >
                  <FontAwesomeIcon icon={faCheck} className="w-[22px] h-[22px]" />
                </button>
              </div>


              {this.state.productId !== "" ? (
                <>
                  {/* <p>Total Qty :- {this.state.qtyCount}</p> */}
                  {/* <p className="!mb-[2px] !mt-[15px] text-[15px] font-medium text-[#474747]">Total NetQty :- {this.state.netQtyCount.toFixed(2)}</p> */}
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`add-btn print:hidden mt-auto`}
                    onClick={() => this.addItemforParty()}

                  >
                    Add Item
                  </button>
                  {(this.state.isSelect === true
                    // && this.state.productId !== ''
                  ) ?
                    <button
                      disabled={this.state.isHideAddItem === true}
                      className="search-btn mt-auto"
                      onClick={() => this.selectRMFormulaForNewProduct()}>Select</button>
                    : null}
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`print-btn print:hidden mt-auto`}
                    // onClick={() => this.printRMFormulaData()}
                    onClick={() => printFunction()}

                  >
                    Print
                  </button>
                  <button
                    disabled={this.state.isHideAddItem === true}
                    className={`cancel-btn print:hidden mt-auto`}
                    onClick={() => this.deleteAllRMFormula()}

                  >
                    Delete All
                  </button>
                </>
              ) : null}

            </div>
          </div>
          <p className="!mb-[2px] text-[15px] font-medium text-[#474747]">Total NetQty :- {this.state.netQtyCount.toFixed(2)}</p>
          <div className="item-listing">
            <div className="itemList-table">
              <div className="table-container" style={{ height: "calc(100vh - 152px)" }} >
                <table className="itemList">
                  <thead style={{ zIndex: "2" }}>
                    <tr>
                      <td className="hidden">Sr</td>
                      <td className="w-[12%]">Stage Name</td>
                      <td className="w-[18%]">Material Name</td>
                      <td className="w-[7%]">L.C.Qty</td>
                      <td className="w-[9%]">L.C. UOM</td>
                      <td className="w-[10%]">Qty</td>
                      <td className="w-[9%]">U-O-M</td>
                      <td className="w-[8%]">Ovrg.[%]</td>
                      <td className="w-[10%]">Net Qty</td>
                      <td className="w-[7%]">Weight</td>
                      <td className="w-[10%] !text-center">Action</td>
                    </tr>
                  </thead>
                  {this.state.rmFormulaList && this.state.rmFormulaList.length > 0
                    ? this.state.rmFormulaList.map((details, key) => (
                      <tbody>
                        <tr>
                          <td className="hidden">{key + 1}</td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="stageName"
                                options={this.state.productionStageList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(
                                    selected,
                                    "stageName",
                                    key
                                  )
                                }
                                allowSelectAll={false}
                                value={this.state.productionStageList.filter(
                                  (party) => party.label === details.stageName
                                )}
                              />
                            ) : (
                              details.stageName
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="rmName"
                                options={this.state.rawMaterialList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(
                                    selected,
                                    "rmName",
                                    key
                                  )
                                }
                                allowSelectAll={false}
                                value={this.state.rawMaterialList.filter(
                                  (party) => party.label === details.rmName
                                )}
                              />
                            ) : (
                              details.rmName
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="lcQty"
                                name="lcQty"
                                value={details.lcQty}
                                autocomplete="off"
                                onChange={(event) =>
                                  this.handleChange(event, "lcQty", key)
                                }
                              />
                            ) : (
                              details.lcQty
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="lcUOM"
                                options={this.state.rmUOMList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(
                                    selected,
                                    "lcUOM",
                                    key
                                  )
                                }
                                allowSelectAll={false}
                                value={this.state.rmUOMList.filter(
                                  (party) => party.label === details.lcUOM
                                )}
                              />
                            ) : (
                              details.lcUOM
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="qty"
                                name="qty"
                                autocomplete="off"
                                value={details.qty}
                                onChange={(event) =>
                                  this.handleChange(event, "qty", key)
                                }
                              />
                            ) : (
                              details.qty
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <MultiSelectDropdown
                                drpIdentity="uom"
                                options={this.state.rmUOMList}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={false}
                                onChange={(selected) =>
                                  this.setFilterParameters(selected, "uom", key)
                                }
                                allowSelectAll={false}
                                value={this.state.rmUOMList.filter(
                                  (party) => party.label === details.uom
                                )}
                              />
                            ) : (
                              details.uom
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="loss"
                                name="loss"
                                autocomplete="off"
                                value={details.loss}
                                onChange={(event) =>
                                  this.handleChange(event, "loss", key)
                                }
                              />
                            ) : (
                              details.loss
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="netQty"
                                name="netQty"
                                autocomplete="off"
                                value={details.netQty}
                                onChange={(event) =>
                                  this.handleChange(event, "netQty", key)
                                }
                                disabled
                              />
                            ) : (
                              details.netQty
                            )}
                          </td>
                          <td>
                            {details.isEditing === true ? (
                              <input
                                className="inputFocus"
                                type="number"
                                id="weight"
                                name="weight"
                                autocomplete="off"
                                value={details.weight}
                                onChange={(event) =>
                                  this.handleChange(event, "weight", key)
                                }
                              />
                            ) : details.weight ? (
                              details.weight
                            ) : (
                              ""
                            )}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {details.isEditing === true ? (
                              // Save
                              <button
                                className="search-btn"
                                onClick={() =>
                                  this.addEditRMFormulaDetails(details)
                                }
                              >
                                <FontAwesomeIcon icon={faCheck} />
                              </button>
                            ) : (
                              // Edit
                              <button
                                className="search-btn"
                                onClick={() => this.editDetails(key)}
                                disabled={this.state.isHideAddItem}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                            )}

                            {details.isEditing === true ? (
                              // Cancel
                              <button
                                className="cancel-btn"
                                onClick={() =>
                                  this.cancelEditing(
                                    details._id ? details._id : "",
                                    key
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faXmark} />
                              </button>
                            ) : (
                              // Delete
                              <button
                                className="cancel-btn"
                                disabled={this.state.isHideAddItem}
                                onClick={() =>
                                  this.deleteRMFurmulaById(
                                    details._id ? details._id : ""
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))
                    : this.state.rmFormulaList
                      && this.state.rmFormulaList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={10} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.rmFormulaList
                      && this.state.rmFormulaList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>

            </div>
          </div>
        </div>
        <ModalBasic
          id="send-for-approve-modal"
          modalOpen={this.state.selectionPopUp}
          setModalOpen={() => this.setModalOpen()}
          title="Existing RM formula"
        >
          <div className="item-search">
            <div className="item-grp">
              <div className="item-search-box" style={{ marginBottom: "15px", width: "50%" }}>
                <label>Item Name</label>
                <MultiSelectDropdown
                  drpIdentity="selectionId"
                  options={this.state.productDropdownList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) => this.setFilterParametersForItemName(selected, "selectionId")}
                  allowSelectAll={false}
                  value={this.state.productDropdownList.filter((party) => party.value === this.state.selectionId)}
                />
              </div>
            </div>
          </div>
          <div className="item-listing">
            <div className="itemList-table ">
              <div className="table-container" style={{ height: "calc(100vh - 300px)" }} >
                <table className="itemList">
                  <thead style={{ zIndex: "2" }}>
                    <tr>
                      <td className="w-[8%] !text-center">
                        <input
                          className="w-[23px] h-[23px]"
                          type="checkbox"
                          id="lcQty"
                          name="lcQty"
                          value={this.state.selectAll}
                          autocomplete="off"
                          onChange={(event) =>
                            this.handleChangeForSelectAll(event)
                          }
                          checked={this.state.selectAll}
                        />
                      </td>
                      <td className="w-[12%]" >Stage Name</td>
                      <td className="w-[22%]">Material Name</td>
                      <td className="w-[7%]">L.C.Qty</td>
                      <td className="w-[8%]">L.C. UOM</td>
                      <td className="w-[10%]">Qty</td>
                      <td className="w-[8%]">U-O-M</td>
                      <td className="w-[8%]">Ovrg.[%]</td>
                      <td className="w-[10%]">Net Qty</td>
                      <td className="w-[7%]">Weight</td>
                    </tr>
                  </thead>
                  {this.state.rmFormulaListForSelection && this.state.rmFormulaListForSelection.length > 0
                    ? this.state.rmFormulaListForSelection.map((details, key) => (
                      <tbody>
                        <tr>
                          <td className="!text-center">
                            <input
                              className="w-[23px] h-[23px]"
                              type="checkbox"
                              id="lcQty"
                              name="lcQty"
                              value={details.checkRMFormula}
                              autocomplete="off"
                              onChange={(event) =>
                                this.handleChangeForImportRMs(event, key)
                              }
                              checked={details.checkRMFormula}
                            />
                          </td>
                          <td>{details.stageName}</td>
                          <td>{details.rmName}</td>
                          <td>{details.lcQty}</td>
                          <td>{details.lcUOM}</td>
                          <td>{details.qty}</td>
                          <td>{details.uom}</td>
                          <td>{details.loss}</td>
                          <td>{details.netQty}</td>
                          <td>{details.weight}</td>
                        </tr>
                      </tbody>
                    ))
                    : null}
                </table>

              </div>
            </div>
          </div>
          <button className="add-btn mt-4" disabled={this.state.isLoading} onClick={() => this.importAllRMFormula()}>
            {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Import"}</button>
        </ModalBasic>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">RM Formula [Item name : {this.state.productDropdownList.find((party) => party.value === this.state.productId)?.label}]</div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
              <div>
                <span className="info-label">Item Name:</span>
                <p className="info-value">Paracetamol</p>
              </div>
            </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "8%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "8%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Sr No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Stage Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    L.C. Qty
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    L.C. UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Qty
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Ovrg.[%]
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Net Qty
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.rmFormulaList && this.state.rmFormulaList.length > 0 ? (
                  this.state.rmFormulaList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {key + 1}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.stageName}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.rmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.lcQty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.lcUOM}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.qty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.uom}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.loss}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.netQty}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </>
    );
  }
}

export default RMFormula;
